import classnames from "classnames";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../../../store/reducer/_uiReducer";
import { getStoredToken } from "../../../../utils";
import { RedirectLogin } from "../../global";
import ErrorContainer from "../_errorContainer";
import Footer from "../_footer";
import Header from "../_header";
import Main from "../_main";
import ModalFilers from "../_modalFilters";
import "./index.scss";

const Pagewrapper = ({
  children,
  footerClass = "",
  fullHeight = false,
  headerClass = "",
  id,
  isModule,
  name,
  protectedPage = false,
  showFooter = false,
  showHeader = false,
}) => {
  const dispatch = useDispatch();
  const pageClass = id && `pdl_page_${id}`;
  const pageTitle = (isModule && name) || null;

  const token = getStoredToken();

  useEffect(() => {
    dispatch(setPageTitle(pageTitle));
    document.title = `Plataforma LEX ${
      (pageTitle && `- ${pageTitle}`) || ""
    }`.trim();
  }, [dispatch, pageTitle]);

  if (!token && protectedPage) return <RedirectLogin />;

  return (
    <div className={classnames("pdl_component_pagewrapper", pageClass)}>
      <ErrorContainer />
      {protectedPage && <RedirectLogin />}
      {showHeader && !!token && <Header headerClass={headerClass} />}
      <Main fullHeight={fullHeight}>{children}</Main>
      {showFooter && <Footer footerClass={footerClass} />}
      <ModalFilers />
    </div>
  );
};

export default Pagewrapper;
